import React from 'react';
import PropTypes from 'prop-types';
import { Interweave } from 'interweave';
function DisplayHTMLContent(props) {
    const { content, wrapperStyle  } = props;
    return (
        <div style={wrapperStyle ? wrapperStyle : null}>
            <Interweave content={content} />
        </div>
    )
}

DisplayHTMLContent.propTypes = {
    content: PropTypes.string.isRequired, // html string
    wrapperStyle: PropTypes.object // css style object
}

export default DisplayHTMLContent

